import React from 'react';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import Info from '@mui/icons-material/Info';

import { Loading } from 'uikit/loaders';
import { Typo } from 'uikit/content';

import { InfoBox, SimpleTabsContainer } from '@/exceed';

import VideosAdminPropertiesGeneralForm from './videosAdminPropertiesGeneralForm';

import styles from '../styles/videosAdminProperties.module.scss';

const VideosAdminProperties = ({
  isChildLocale,
  videoProperties,
  videoPropertiesKey,
  isFormDisabled,
  onCancel,
  onSubmit,
  onUpdate,
}) => {
  const videosType = useParams().type;

  if (videoProperties.isLoading) {
    return <Loading />;
  }

  const renderFormsFor = (sections) => (
    <main>
      {isChildLocale && (
        <InfoBox className={styles.infoBox}>
          <Info className={styles.infoBoxIcon} sx={{ height: 18, width: 18 }} />
          <Typo element="span" variant="b01">{i18n.t('properties-locale-versions-alert')}</Typo>
        </InfoBox>
      )}
      {sections.map((section) => {
        if (!section) return;

        return (
          <VideosAdminPropertiesGeneralForm
            key={section}
            section={section}
            videoProperties={videoProperties}
            videoPropertiesKey={videoPropertiesKey}
            isChildLocale={isChildLocale}
            isDisabled={isFormDisabled}
            onCancel={onCancel}
            onSubmit={onSubmit}
            onUpdate={onUpdate}
          />
        );
      })}
    </main>
  );

  const tabs = [
    {
      id: 'general',
      title: i18n.t('general'),
      body: renderFormsFor(
        [
          'general',
          videosType === 'on-demand' ? 'video' : 'video_trailer',
          'display',
          'additional_details',
          videosType === 'on-demand' && 'associations',
          'social',
          'custom_fields',
        ].filter(Boolean),
      ),
    },
    {
      id: 'catalog',
      title: i18n.t('catalog'),
      body: renderFormsFor([
        'catalog',
        videosType === 'live' && 'public_properties',
        'tagging',
        'seo_properties',
      ]),
    },
  ];
  if (videosType === 'live' && !isChildLocale) {
    tabs.push(
      {
        id: 'enrollment',
        title: i18n.t('enrollment'),
        body: renderFormsFor(['enrollment']),
      },
      {
        id: 'advanced',
        title: i18n.t('advanced'),
        body: renderFormsFor(['advanced_properties']),
      },
    );
  }

  return (
    <SimpleTabsContainer direction="vertical" queryParamsToPersist={['version_id']} tabs={tabs} />
  );
};

VideosAdminProperties.propTypes = {};

export default React.memo(VideosAdminProperties);
